import { useEmailConfirmationModal } from "@js/apps/dashboard/hooks/use-email-confirmation-modal";

import { IdentityVerificationModalInstance } from "../identity-verification";
import { usePollWalletStatus } from "../on-ramp/hooks/use-poll-wallet-status";
import { useShowPendingOnrampTransaction } from "../on-ramp/hooks/use-show-pending-onramp-transaction";
import { AddWithdrawalMethodModal } from "../withdrawal/components/add-withdrawal-method";
import WithdrawalMethodWarning from "../withdrawal/components/withdrawal-method-warning";

import { FreelancerBillingAnnouncementProvider } from "./components/freelancer-billing-announcement-provider";

const pathToShowConfirmationModal = /^\/talent\/dashboard\/welcome\/?$/;
export const FreelancerGlobalProvider = () => {
  useEmailConfirmationModal({
    pathToShowConfirmationModal,
  });
  usePollWalletStatus();
  useShowPendingOnrampTransaction();

  return (
    <>
      <IdentityVerificationModalInstance />
      <WithdrawalMethodWarning />
      <AddWithdrawalMethodModal />
      <FreelancerBillingAnnouncementProvider />
    </>
  );
};
